export default __webpack_public_path__ + "static/media/course.3922be21.svg";